import React, { useEffect, useState } from 'react'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { withRouter } from 'react-router'
import Sticky from 'react-stickynode'
import { connect } from 'react-redux'

import { toggleSignUpModal } from '../../Manage/actions'
import CTAButton from '../CTAButton/CTAButton'
import SignUpPage from 'Login/SignUpModal'
import CustomModal from 'components/CustomModal/CustomModal'
import useCheckIsMobileScreen from '../../hooks/checkMobileScreen'
import { features, useCases } from '../../constants/navMenus'

import './HomePageHeader.css'

const renderIconMenuItems = (items) =>
  items.map(({ name, href, icon, description }) => (
    <NavDropdown.Item key={href} href={href} className="icon-menu-item">
      <span className="icon-menu-icon" aria-hidden="true">
        <img src={`/assets/icons/${icon}`} alt="" />
      </span>
      <span className="icon-menu-copy">
        <span className="icon-menu-title">{name}</span>
        <span className="icon-menu-description">{description}</span>
      </span>
    </NavDropdown.Item>
  ))

const HomePageHeader = ({ dispatch, history, showSignUpModal, simplified, logoOnly }) => {
  const [sticky, setSticky] = useState(false)
  const [showResources, setShowResources] = useState(false)
  const [showFor, setShowFor] = useState(false)
  const [showFeature, setShowFeature] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const { isMobile } = useCheckIsMobileScreen()
  const hasHoverSupport =
    typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(hover: hover)').matches

  useEffect(() => {
    document.addEventListener('touchstart', () => {}, false)
  }, [])

  if (logoOnly) {
    return (
      <Navbar bg="white" className="home-navbar">
        <Navbar.Brand href="/">
          <img className="home-header-logo" src="/assets/logo.png" alt="tiny.host" />
        </Navbar.Brand>
      </Navbar>
    )
  }

  const handleStateChange = (status) => {
    setSticky(status.status === Sticky.STATUS_FIXED)
  }

  const signedIn = Boolean(localStorage.getItem('token'))
  const isLoginPage = window.location.pathname === '/login'
  const isTransferRequestLink = window.location.pathname.includes('/transfer-request/')

  return (
    <Sticky enabled={!isMobile} innerClass={sticky ? 'sticky' : ''} onStateChange={handleStateChange} innerZ={999}>
      <Navbar
        bg="white"
        expand="lg"
        collapseOnSelect
        expanded={expanded}
        onToggle={setExpanded}
        className="home-navbar"
      >
        <Navbar.Brand className="d-l-none d-block" href="/">
          <img className="home-header-logo" src="/assets/logo.png" alt="tiny.host" onClick={() => history.push('/')} />
        </Navbar.Brand>
        <Navbar.Toggle className="ms-3" aria-controls="responsive-navbar-nav" />
        <Navbar.Brand className="d-none d-l-block" href="/">
          <img className="home-header-logo" src="/assets/logo.png" alt="tiny.host" onClick={() => history.push('/')} />
        </Navbar.Brand>
        <Navbar.Collapse id="responsive-navbar-nav" className={expanded ? 'mobile-menu-open' : ''}>
          <button
            type="button"
            className="mobile-menu-close"
            aria-label="Close menu"
            onClick={() => setExpanded(false)}
          >
            &times;
          </button>
          {!simplified && (
            <Nav className="ms-l-3">
              <Nav.Link className="menu-link" href="https://api-docs.tiiny.host" target="_blank">
                API
              </Nav.Link>
              <Nav.Link
                className="menu-link"
                onClick={() => {
                  history.push('/pricing')
                  setExpanded(false)
                }}
              >
                Pricing
              </Nav.Link>
              <NavDropdown
                title="Features"
                id="feature-dropdown"
                className="menu-link icon-menu"
                show={showFeature}
                onMouseEnter={hasHoverSupport ? () => setShowFeature(true) : undefined}
                onMouseLeave={hasHoverSupport ? () => setShowFeature(false) : undefined}
                onToggle={(nextShow) => setShowFeature(nextShow)}
              >
                {renderIconMenuItems(features)}
              </NavDropdown>
              <NavDropdown
                title="For"
                id="for-dropdown"
                className="menu-link icon-menu"
                show={showFor}
                onMouseEnter={hasHoverSupport ? () => setShowFor(true) : undefined}
                onMouseLeave={hasHoverSupport ? () => setShowFor(false) : undefined}
                onToggle={(nextShow) => setShowFor(nextShow)}
              >
                {renderIconMenuItems(useCases)}
              </NavDropdown>
              <NavDropdown
                title="Resources"
                id="resources-dropdown"
                className="menu-link"
                show={showResources}
                onMouseEnter={hasHoverSupport ? () => setShowResources(true) : undefined}
                onMouseLeave={hasHoverSupport ? () => setShowResources(false) : undefined}
                onToggle={(nextShow) => setShowResources(nextShow)}
              >
                <NavDropdown.Item href="/blog/">Blog</NavDropdown.Item>
                <NavDropdown.Item href="/customers">Customer stories</NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => {
                    history.push('/help')
                    setExpanded(false)
                  }}
                >
                  Help
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          )}
          <Nav className="me-auto" />
          {!isLoginPage ? (
            <Nav>
              {!simplified && (
                <>
                  <Nav.Link
                    className="menu-link"
                    onClick={() => {
                      history.push('/contact-sales')
                      setExpanded(false)
                    }}
                  >
                    Contact sales
                  </Nav.Link>
                  {!isTransferRequestLink && !signedIn && (
                    <Nav.Link>
                      <CTAButton
                        className="m-auto"
                        label="Log in"
                        onClick={() => {
                          history.push('/login')
                          setExpanded(false)
                        }}
                        size="small"
                        variant="secondary-round"
                        showArrow={false}
                      />
                    </Nav.Link>
                  )}
                </>
              )}
              <Nav.Link>
                <CTAButton
                  className="m-auto"
                  label={signedIn ? 'Dashboard' : 'Sign up free'}
                  onClick={() => {
                    if (signedIn) {
                      history.push('/manage')
                    } else {
                      dispatch(toggleSignUpModal(true))
                    }
                    setExpanded(false)
                  }}
                  size="small"
                  variant={isTransferRequestLink ? 'secondary-outline' : 'primary-gradient-round'}
                />
              </Nav.Link>
            </Nav>
          ) : null}
        </Navbar.Collapse>
      </Navbar>
      {expanded && <div className="mobile-menu-backdrop" onClick={() => setExpanded(false)} />}
      <CustomModal
        show={showSignUpModal}
        onHide={() => dispatch(toggleSignUpModal(false))}
        centered
        enforceFocus={false}
        mobileCloseButton={false}
        size="sm"
      >
        <div className="modal-signup-container">
          <SignUpPage isModal={true} />
        </div>
      </CustomModal>
    </Sticky>
  )
}

const mapDispatchToProps = (dispatch) => ({ dispatch })
const mapStateToProps = (state) => ({
  isLoading: !state.manage.userProfile.email,
  showSignUpModal: state.manage.showSignUpModal
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HomePageHeader))
